import { TEXTS_VARIABLE } from 'src/app/shared/constants/constants-texts';
import { IEquisBreadcrumbTree } from 'src/app/shared/models/breadcrumb';
import { URL_DOMAIN } from 'src/environments/environment';

export const createBreadcrumbNode = ({
  title,
  path,
  params = '',
  active = true,
  parentTitle = '',
  id,
  parentId = '',
}: Partial<IEquisBreadcrumbTree> & {
  title: string;
  path: string;
  id: string;
}): IEquisBreadcrumbTree => {
  return {
    title,
    path,
    children: [],
    params,
    active,
    parentTitle,
    id,
    parentId,
  };
};

export const InicioNode = createBreadcrumbNode({
  title: 'Inicio',
  path: URL_DOMAIN,
  id: 'inicio',
  active: false,
});
export const CANode = createBreadcrumbNode({
  title: TEXTS_VARIABLE.breadcrumb.HelpCenter,
  path: '',
  id: 'ayuda',
  parentTitle: InicioNode.title,
  parentId: InicioNode.id,
});
export const EmptyNode = createBreadcrumbNode({
  title: '',
  path: '/',
  id: 'empty',
  parentTitle: CANode.title,
  parentId: CANode.id,
});
